import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

import './FdicBanner.css';

const DEFAULT_ICON_WIDTH = 38;
const DEFAULT_ICON_HEIGHT = 16;

interface IFdicBannerProps extends MappedComponentProperties {
    iconPath?: string;
    version?: "grey" | "blue";
    bannerText?: string;
}

export const FdicBannerEditConfig = {
    emptyLabel: 'FDIC Banner',
    isEmpty: (props: PropsWithChildren<IFdicBannerProps>) => {
        return !props || !props.iconPath;
    },
};

const FdicBanner = (props: IFdicBannerProps): JSX.Element => {
    return (
        <div className={`FdicBanner ${props.version === 'grey' ? 'bg-grey-alabaster' : 'bg-blue-banner' }`}>
            <div className='FdicBanner__content flex items-center justify-center mx-auto my-0'>
                <img
                    className='FdicBanner__icon flex-shrink-0 my-0'
                    src={props.iconPath}
                    alt='FDIC Logo'
                    width={DEFAULT_ICON_WIDTH}
                    height={DEFAULT_ICON_HEIGHT}
                />
                <p className={`FdicBanner__text m-0 ${props.version === 'grey' ? 'text-grey-tundora' : 'text-white'}`}>
                    {transformHTMLParserLinks(props.bannerText)}
                </p>
            </div>
        </div>
    );
};

export default FdicBanner;
        
